import { Component } from '@angular/core';
import { LADAAT_SERVER } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ladaat-client';
  d = LADAAT_SERVER

  constructor()
  {
    
    // window.onbeforeunload = () => {
    //   localStorage.clear()
    // }

  }
  
}
